import { debounce } from '../helper/debouncer';
import { getNavigatorConnection } from '../chrome/wrappers';
import { getDeviceStore } from '../storage/stores';
import { Mutex } from 'async-mutex';

const networkChangeMutex = new Mutex();
/**
 * Calls the provided function on every network change.
 *
 * If available, it uses the connection type changes (none, wifi, ethernet...) to determine if the network changed.
 * Otherwise, it will be every time the navigator.connection.onchange detects a change, but could include false-positives.
 */
export const registerNetworkChangeListener = (
  callback: () => Promise<void> | undefined
) => {
  // Available from Chrome 61 (Released Sept. 2017)
  const navigatorConnection = getNavigatorConnection();
  if (navigatorConnection) {
    const debouncedCallback = debounce(callback, 1500);
    navigatorConnection.onchange = () =>
      networkChangeMutex.runExclusive(() => {
        const type = navigatorConnection.type;
        if (type) {
          const lastType = getDeviceStore().getLastNetworkConnectionType();
          if (type !== lastType) {
            console.log('Network state changed!');
            callback();
          }
          getDeviceStore().setLastNetworkConnectionType(type);
        } else {
          console.log('Network state changed!');
          // Since multiple events might be received at the same time, we need to debounce the call.
          debouncedCallback();
        }
      });
  } else {
    console.warn('Navigator.connection not supported!');
  }
};
